import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-mjls",
  "use": "icon-mjls-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-mjls\"><defs><style type=\"text/css\"></style></defs><path d=\"M768 128a64 64 0 0 1 64 64v640a64 64 0 0 1-64 64H256a64 64 0 0 1-64-64V192a64 64 0 0 1 64-64h512z m0 64H256v640h512V192z m-96 32a64 64 0 0 1 64 64v448a64 64 0 0 1-64 64H352a64 64 0 0 1-64-64V288a64 64 0 0 1 64-64h320z m0 64H352v448h320V288z m-32 160v128h-64v-128h64z\" p-id=\"11876\" fill=\"#ffffff\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol